'use strict'

import * as types from '@/store/types.js'

const state = {
  tryInit: false
}

const mutations = {
  [types.GUI.tryInit.set]: (store) => {
    store.tryInit = true
  }
}

const actions = {
  [types.GUI.tryInit.set](context) {
    context.commit(types.GUI.tryInit.set)
  }
}

export default {
  state,
  mutations,
  actions
}
